<template>
    <!-- <v-footer
      color="#0b5b9e"
      app
    > -->
    <v-footer
      color="black"
      app
    >    
      <span class="white--text">dmecomply LLC &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
</template>

<script>
export default {
    name: "Footer"
}
</script>